import { render, staticRenderFns } from "./SelectCustomerStatuses.vue?vue&type=template&id=40ec9c45"
import script from "./SelectCustomerStatuses.vue?vue&type=script&lang=js"
export * from "./SelectCustomerStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports